import { Shield, Truck } from "lucide-react";
import { Toggle } from "../ui/toggle";
import { dictionary } from "../../../utils/dictionary";
import { useAuth } from "../../../context/AuthContext";

interface WarrantyAndFreeShippingProps {
  warrantyEnabled: boolean;
  handleWarrantyToggle: (enabled: boolean) => void;
  customWarrantyDays: number | string;
  handleCustomWarrantyChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  freeShippingEnabled: boolean;
  handleFreeShippingToggle: (enabled: boolean) => void;
}

function WarrantyAndFreeShipping({
  warrantyEnabled, handleWarrantyToggle,
  customWarrantyDays, handleCustomWarrantyChange,
  freeShippingEnabled, handleFreeShippingToggle
}: WarrantyAndFreeShippingProps) {
  const { language } = useAuth();

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border border-gray-200 rounded-lg p-4 shadow-sm">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-primary-100 rounded-full">
                <Shield className="w-5 h-5 text-primary-600" />
              </div>
              <h3 className="text-lg font-medium">{dictionary["money-back-guarantee"][language]}</h3>
            </div>
            <Toggle
              enabled={warrantyEnabled}
              onChange={handleWarrantyToggle}
            />
          </div>

          {warrantyEnabled && (
            <div className="mt-3 flex items-center">
              <div className="flex items-center">
                <div className="border border-primary-300 rounded-lg overflow-hidden">
                  <input
                    type="number"
                    min="1"
                    className="w-14 px-2 py-1 text-center focus:outline-none text-sm"
                    value={customWarrantyDays}
                    onChange={handleCustomWarrantyChange}
                  />
                </div>
                <span className="text-gray-600 ml-1 text-sm">{dictionary["days"][language]}</span>
              </div>
            </div>
          )}
        </div>

        <div className="border border-gray-200 rounded-lg p-4 shadow-sm">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="p-2 bg-primary-100 rounded-full mr-3">
                <Truck className="w-5 h-5 text-primary-600" />
              </div>
              <h3 className="text-lg font-medium">{dictionary["free-shipfping"][language]}</h3>
            </div>
            <Toggle
              enabled={freeShippingEnabled}
              onChange={handleFreeShippingToggle}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default WarrantyAndFreeShipping;